import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@homeaway/react-buttons';
import {Link as LocalizedLink} from '@homeaway/react-localization-components';

import translate from '../../../utils/translations';
import {IpmHostInfo} from '../IpmHostInfo/IpmHostInfo';

import './PropertyContact.less';

export class PropertyContact extends React.PureComponent {
    static propTypes = {
        avatar: PropTypes.string,
        backUrl: PropTypes.string,
        conversationId: PropTypes.string,
        memberSince: PropTypes.string,
        ownerName: PropTypes.string,
        phone: PropTypes.string,
        responseTime: PropTypes.string,
        showSendMessageBtn: PropTypes.bool,
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        avatar: 'http://csvcus.homeaway.com/rsrcs/cdn-logos/2.14.0/bce/brand/misc/default-profile-pic.svg',
        backUrl: '/traveler/th/inbox',
        showSendMessageBtn: false,
        translations: {},
    };

    render() {
        const {
            avatar,
            conversationId,
            memberSince,
            ownerName,
            phone,
            responseTime,
            showIpmHostInfo,
            showSendMessageBtn,
            translations,
        } = this.props;

        if (!avatar && !ownerName && !phone && !showSendMessageBtn) {
            return null;
        }

        return (
            <>
                <div className="PropertyContact conversation-sidebar-section rounded-border text-center">
                    {avatar && (
                        <div
                            className="PropertyContact__image img-circle"
                            style={{backgroundImage: `url(${avatar})`}}
                        />
                    )}
                    <div className="PropertyContact__name-container">
                        {ownerName && (
                            <h3 className="PropertyContact__name">
                                {ownerName}
                            </h3>
                        )}
                        {memberSince && (
                            <span>
                                {translate(
                                    translations,
                                    'trav-dash/trav-home',
                                    'messages',
                                    'th.inbox.conversation.ownerSummary.since',
                                    {0: memberSince}
                                )}
                            </span>
                        )}
                        {phone && <h4>{phone}</h4>}
                        {!showSendMessageBtn && responseTime && (
                            <div className="PropertyContact__response">
                                {responseTime}
                            </div>
                        )}
                    </div>
                    {showSendMessageBtn && (
                        <LocalizedLink
                            data-testid="localisedlink"
                            href={`/traveler/th/inbox/conversation/${conversationId}/messages`}
                        >
                            <Button
                                className={'hidden-print btn--nowrap'}
                                label={`${translate(
                                    translations,
                                    'trav-dash/trav-home',
                                    'messages',
                                    'th.details.propertyContact.sendMessage'
                                )} `}
                            />
                        </LocalizedLink>
                    )}
                </div>
                {showIpmHostInfo && <IpmHostInfo translations={translations} />}
            </>
        );
    }
}
